import axios from 'axios';
import Dashboard from './main-views/Dashboard';
import ClassroomOptions from './views/ClassroomOptions';
import ClassroomStudents from './views/ClassroomStudents';
import SubjectOptions from './views/SubjectOptions';
import ExamCycleOptions from './views/ExamCycleOptions';
import StreamOptions from './views/StreamOptions';
import Classrooms from './main-views/Classrooms';
import Subjects from './main-views/Subjects';
import GeneralPaymentCycles from './main-views/GeneralPaymentCycles';
import GeneralPaymentCycleOptions from './views/GeneralPaymentCycleOptions';
import IndividualPaymentCycles from './main-views/IndividualPaymentCycles';
import IndividualPaymentCycleOptions from './views/IndividualPaymentCycleOptions';
import StudentOptions from './views/StudentOptions';
import StudentPaymentsProfile from './views/StudentPaymentsProfile';
import StudentAcademicProfile from './views/StudentAcademicProfile';
import GeneralPaymentCycleCollections from './views/GeneralPaymentCycleCollections';
import IndividualPaymentCycleCollections from './views/IndividualPaymentCycleCollections';
import PaymentRecordOptions from './views/PaymentRecordOptions';
import Staff from './main-views/Staff';
import StaffOptions from './views/StaffOptions';
import ExamCycleResultsEditor from './views/ExamCycleResultsEditor';
import ExamCycleResultsProcessor from './views/ExamCycleResultsProcessor';
import ExamCycleResultsViewer from './views/ExamCycleResultsViewer';
import Accounting from './main-views/Accounting';
import GradingSystems from './main-views/GradingSystems';
import MyActivities from './main-views/MyActivities';
import Students from './main-views/Students';
import ViewStudentExamCycleResult from './views/ViewStudentExamCycleResult';
import StreamStudents from './views/StreamStudents';
import GradingSystemOptions from './views/GradingSystemOptions';
import * as XLSX from "xlsx";
import ParentalCommunications from './main-views/ParentalCommunications';
import DebtOptions from './views/DebtOptions';
import DebtCollections from './views/DebtCollections';
import StudentEditDetails from './views/StudentEditDetails';
import Reports from './main-views/Reports';
import ViewClasroomDebtsReport from './views/ViewClassroomDebtsReport';
import ViewGeneralPaymentCycleCollectionReport from './views/ViewGeneralPaymentCycleCollectionReport';
import ViewIndividualPaymentCycleCollectionReport from './views/ViewIndividualPaymentCycleCollectionReport';


export const BASE_API = 'https://ssidapi.werenium.com/api/school/';

export const CDN_URL = 'https://ssid.werenium.com/cdn/'


export function getMainView(app) {
  if (app.navItem === 'dashboard' || !app.navItem) {
    return <Dashboard />
  } else if (app.navItem === 'classrooms') {
    return <Classrooms/>;
  } else if (app.navItem === 'subjects') {
    return <Subjects/>;
  } else if (app.navItem === 'general_payment_cycles') {
    return <GeneralPaymentCycles/>;
  } else if (app.navItem === 'individual_payment_cycles') {
    return <IndividualPaymentCycles/>;
  } else if (app.navItem === 'staff') {
    return <Staff/>;
  } else if (app.navItem === 'accounting') {
    return <Accounting/>;
  } else if (app.navItem === 'grading_systems') {
    return <GradingSystems/>;
  } else if (app.navItem === 'my_activities') {
    return <MyActivities/>;
  } else if (app.navItem === 'students') {
    return <Students/>;
  } else if (app.navItem === 'parental_communications') {
    return <ParentalCommunications/>;
  } else if (app.navItem === 'reports') {
    return <Reports/>;
  } 

  return null;
}

export function getViewerView(app) {
  if (
    app.navSubItem === 'create-user' &&
    !app.navExtraItem &&
    !app.navMoreItem
  ) {
    return '';
  } else if (
    app.navSubItem === 'classroom-students' &&
    app.navExtraItem &&
    !app.navMoreItem
  ) {
    return (
      <ClassroomStudents uuid={app.navExtraItem} />
    );
  } else if (
    app.navSubItem === 'stream-students' &&
    app.navExtraItem &&
    !app.navMoreItem
  ) {
    return (
      <StreamStudents uuid={app.navExtraItem} />
    );
  } else if (
    app.navSubItem === 'classroom-options' &&
    app.navExtraItem &&
    !app.navMoreItem
  ) {
    return (
      <ClassroomOptions uuid={app.navExtraItem} />
    );
  } else if (
    app.navSubItem === 'stream-options' &&
    app.navExtraItem &&
    !app.navMoreItem
  ) {
    return (
      <StreamOptions uuid={app.navExtraItem} />
    );
  } else if (
    app.navSubItem === 'general-payment-cycle-options' &&
    app.navExtraItem &&
    !app.navMoreItem
  ) {
    return (
      <GeneralPaymentCycleOptions uuid={app.navExtraItem} />
    );
  } else if (
    app.navSubItem === 'individual-payment-cycle-options' &&
    app.navExtraItem &&
    !app.navMoreItem
  ) {
    return (
      <IndividualPaymentCycleOptions uuid={app.navExtraItem} />
    );
  } else if (
    app.navSubItem === 'debt-options' &&
    app.navExtraItem &&
    !app.navMoreItem
  ) {
    return (
      <DebtOptions uuid={app.navExtraItem} />
    );
  } else if (
    app.navSubItem === 'classroom-debts-report' &&
    !app.navExtraItem &&
    !app.navMoreItem
  ) {
    return (
      <ViewClasroomDebtsReport uuid={app.navExtraItem} />
    );
  } else if (
    app.navSubItem === 'general-payment-cycle-collection-report' &&
    !app.navExtraItem &&
    !app.navMoreItem
  ) {
    return (
      <ViewGeneralPaymentCycleCollectionReport uuid={app.navExtraItem} />
    );
  } else if (
    app.navSubItem === 'individual-payment-cycle-collection-report' &&
    !app.navExtraItem &&
    !app.navMoreItem
  ) {
    return (
      <ViewIndividualPaymentCycleCollectionReport uuid={app.navExtraItem} />
    );
  }

  return null;
}

export function getSideViewerView(app) {
  if (
    app.navSubItem === 'classroom-options' &&
    app.navExtraItem &&
    !app.navMoreItem
  ) {
    return (
      <ClassroomOptions uuid={app.navExtraItem} />
    );
  } else if (
    app.navSubItem === 'subject-options' &&
    app.navExtraItem &&
    !app.navMoreItem
  ) {
    return (
      <SubjectOptions uuid={app.navExtraItem} />
    );
  } else if (
    app.navSubItem === 'exam-cycle-options' &&
    app.navExtraItem &&
    !app.navMoreItem
  ) {
    return (
      <ExamCycleOptions uuid={app.navExtraItem} />
    );
  } else if (
    app.navSubItem === 'exam-cycle-results-editor' &&
    app.navExtraItem &&
    !app.navMoreItem
  ) {
    return (
      <ExamCycleResultsEditor examCycleUuid={app.navExtraItem} />
    );
  } else if (
    app.navSubItem === 'exam-cycle-results-processor' &&
    app.navExtraItem &&
    !app.navMoreItem
  ) {
    return (
      <ExamCycleResultsProcessor examCycleUuid={app.navExtraItem} />
    );
  } else if (
    app.navSubItem === 'exam-cycle-results-viewer' &&
    app.navExtraItem &&
    !app.navMoreItem
  ) {
    return (
      <ExamCycleResultsViewer examCycleUuid={app.navExtraItem} />
    );
  } else if (
    app.navSubItem === 'staff-options' &&
    app.navExtraItem &&
    !app.navMoreItem
  ) {
    return (
      <StaffOptions uuid={app.navExtraItem} />
    );
  } else if (
    app.navSubItem === 'stream-options' &&
    app.navExtraItem &&
    !app.navMoreItem
  ) {
    return (
      <StreamOptions uuid={app.navExtraItem} />
    );
  } else if (
    app.navSubItem === 'classroom-students' &&
    app.navExtraItem &&
    !app.navMoreItem
  ) {
    return (
      <ClassroomStudents uuid={app.navExtraItem} />
    );
  } else if (
    app.navSubItem === 'general-payment-cycle-options' &&
    app.navExtraItem &&
    !app.navMoreItem
  ) {
    return (
      <GeneralPaymentCycleOptions uuid={app.navExtraItem} />
    );
  } else if (
    app.navSubItem === 'general-payment-cycle-collections' &&
    app.navExtraItem &&
    app.navMoreItem
  ) {
    return (
      <GeneralPaymentCycleCollections 
        generalPaymentCycleUuid={app.navExtraItem} 
        studentUuid={app.navMoreItem}
      />
    );
  } else if (
    app.navSubItem === 'individual-payment-cycle-collections' &&
    app.navExtraItem &&
    app.navMoreItem
  ) {
    return (
      <IndividualPaymentCycleCollections 
        individualPaymentCycleUuid={app.navExtraItem} 
        studentUuid={app.navMoreItem}
      />
    );
  } else if (
    app.navSubItem === 'individual-payment-cycle-options' &&
    app.navExtraItem &&
    !app.navMoreItem
  ) {
    return (
      <IndividualPaymentCycleOptions uuid={app.navExtraItem} />
    );
  } else if (
    app.navSubItem === 'student-options' &&
    app.navExtraItem &&
    !app.navMoreItem
  ) {
    return (
      <StudentOptions uuid={app.navExtraItem} />
    );
  } else if (
    app.navSubItem === 'student-edit-details' &&
    app.navExtraItem &&
    !app.navMoreItem
  ) {
    return (
      <StudentEditDetails uuid={app.navExtraItem} />
    );
  } else if (
    app.navSubItem === 'grading-system-options' &&
    app.navExtraItem &&
    !app.navMoreItem
  ) {
    return (
      <GradingSystemOptions uuid={app.navExtraItem} />
    );
  } else if (
    app.navSubItem === 'student-payments-profile' &&
    app.navExtraItem &&
    !app.navMoreItem
  ) {
    return (
      <StudentPaymentsProfile uuid={app.navExtraItem} />
    );
  } else if (
    app.navSubItem === 'student-academic-profile' &&
    app.navExtraItem &&
    !app.navMoreItem
  ) {
    return (
      <StudentAcademicProfile uuid={app.navExtraItem} />
    );
  } else if (
    app.navSubItem === 'payment-record-options' &&
    app.navExtraItem &&
    !app.navMoreItem
  ) {
    return (
      <PaymentRecordOptions uuid={app.navExtraItem} />
    );
  } else if (
    app.navSubItem === 'view-student-exam-cycle-result' &&
    app.navExtraItem &&
    app.navMoreItem
  ) {
    return (
      <ViewStudentExamCycleResult studentUuid={app.navExtraItem} examCycleUuid={app.navMoreItem} />
    );
  } else if (
    app.navSubItem === 'debt-options' &&
    app.navExtraItem &&
    !app.navMoreItem
  ) {
    return (
      <DebtOptions uuid={app.navExtraItem} />
    );
  } else if (
    app.navSubItem === 'debt-collections' &&
    app.navExtraItem &&
    app.navMoreItem
  ) {
    return (
      <DebtCollections studentUuid={app.navMoreItem} debtUuid={app.navExtraItem} />
    );
  }

  return null;
}


export function getInlineLoader() {
  return (
    <div className="Loader"></div>
  )
}

export function getCurrentTimestamp() {
  return Math.round(Date.now() / 1000);
}

export function areTimestampsOfSameDateYearMonth(timestamp1, timestamp2) {
  // Convert timestamps from seconds to milliseconds
  const date1 = new Date(timestamp1 * 1000);
  const date2 = new Date(timestamp2 * 1000);
  
  // Compare year, month, and date
  return date1.getFullYear() === date2.getFullYear() &&
         date1.getMonth() === date2.getMonth() &&
         date1.getDate() === date2.getDate();
}

export function formatDate(timestamp, fromPhp = true) {
  timestamp = (fromPhp) ? Number(timestamp) * 1000 : timestamp;
  let date = new Date(timestamp);
  return (date.toLocaleString());
}

export function callApi(url, params) {
  return new Promise(async resolve => {
    await getLocalUser().then(user => {
      // .. setup form data
      let formData = new FormData();
      formData.append('language', 'en');

      for (let key in params) {
        formData.append(key, params[key]);
      }

      for (let key in user) {
        formData.append(key, user[key]);
      }

      // Retry mechanism: try up to 3 times
      let attempt = 0;
      const maxRetries = 1;

      const makeRequest = async () => {
        try {
          const response = await axios.post(BASE_API + url, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          });
          console.log(url, response.data);
          resolve(response.data); // Successfully resolve with response data
        } catch (error) {
          attempt++;
          if (attempt < maxRetries) {
            console.log(`Attempt ${attempt} failed. Retrying...`);
            makeRequest(); // Retry the request
          } else {
            resolve({
              status: 0,
              msg: "Network Connection Error after 3 attempts",
            }); // Resolve after 3 failed attempts
          }
        }
      };

      // Start the request attempts
      makeRequest();
    });
  });
}

export function getLocalUser() {
  return new Promise(async resolve => {
    //use cookies
    let userUuid = getCookie('userUuid');
    let userToken = getCookie('userToken');

    resolve({
      userUuid,
      userToken,
    })


  })
}

export function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  cname = 'ssid-school-portal-'+cname;
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  let expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

export function getCookie(cname) {
  cname = 'ssid-school-portal-'+cname;
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

export function strtotime(dateString) {
  const date = new Date(dateString);
  return Math.floor(date.getTime() / 1000);
}

export function formatMoney(x) {
  //round x to 2 decimal places before og function
  x = Number(x);
  x = x.toFixed(0);

  //then continue
  var parts = x.toString().split(".");
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return parts.join(".");
}

export function formatMoneyShorten(num, digits = 2) {
  num = Number.parseFloat(num);
  if (num <= 1 && num >= -1) {
    return num;
  }

  const lookup = [
    { value: 1, symbol: "" },
    { value: 1e3, symbol: "K" },
    { value: 1e6, symbol: "M" },
    { value: 1e9, symbol: "B" },
    { value: 1e12, symbol: "T" },
    { value: 1e15, symbol: "P" },
    { value: 1e18, symbol: "E" }
  ];
  const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
  var item = lookup.slice().reverse().find(function (item) {
    return Math.abs(num) >= item.value; // Use absolute value of num
  });
  return item ? (num / item.value).toFixed(digits).replace(rx, "$1") + item.symbol : "0";
}

export function stringToArray(string) {
  const array = string.split(",").map(item => item.trim());
  return array;
}

export function arrayToString(arr) {
  return arr.join(', ');
}

export function isNapaLocationValid (location) {

  return true;
  
  if(location && location.region && location.district && location.ward ) {
    return true;
  } else {
    return false;
  }
}

export function timestampToDateForInput(timestamp) {
  // Convert the timestamp (seconds) into milliseconds
  const date = new Date(timestamp * 1000);
  
  // Get the date in YYYY-MM-DD format
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based, so add 1
  const day = String(date.getDate()).padStart(2, '0');
  
  // Return the formatted date string in the form of YYYY-MM-DD
  return `${year}-${month}-${day}`;
}

export function roundToTwoDecimals(value) {
  if (Number.isInteger(value)) {
    return value; // no decimals, return as-is
  }
  return Math.round(value * 100) / 100; // round to 2 decimal places
}

export function formatExcelDate(value) {
  if (typeof value === "number") {
    const parsed = XLSX.SSF.parse_date_code(value);
    if (parsed) {
      const yyyy = parsed.y;
      const mm = String(parsed.m).padStart(2, "0");
      const dd = String(parsed.d).padStart(2, "0");
      return `${yyyy}-${mm}-${dd}`;
    }
  }
  return value; // already a string or null
}

export function getCurrentDateForInput() {
	const today = new Date();
	const year = today.getFullYear();
	const month = String(today.getMonth() + 1).padStart(2, '0');
	const day = String(today.getDate()).padStart(2, '0');

	return `${year}-${month}-${day}`;
}
